<template>
    <div class="overview" v-if="buildings.length > 0">
        <div :key="building.id" v-for="(building, index) in buildings" class="show-control">
            <elementary-section shadow :light="index % 2 === 0 ? false : true">
                <div class="container">
                    <div class="overview__header">
                        <h3 class="overview__title">{{ building.title }}</h3>

                        <div class="overview__controls overview__controls--in-header z1">
                            <custom-button @click="update(building.id)" iconic>
                                <span icon edit></span>Upravit
                            </custom-button>
                            <custom-button @click="remove(building)" iconic class="visible-on-overview-hover">
                                <span icon remove></span>Odstranit
                            </custom-button>
                        </div>
                    </div>
                    <p class="overview__description" v-if="building.description">
                        {{ building.description }}
                    </p>
                    <p class="overview__description">
                        <span class="overview__partials" v-if="building.numberOfFloors">
                            Počet pater <strong class="text--info">{{ building.numberOfFloors }}</strong>
                        </span>
                        <span class="overview__partials" v-if="building.numberOfFloorsAboveGround">
                            Počet NP <strong class="text--info">{{ building.numberOfFloorsAboveGround }}</strong>
                        </span>
                        <span class="overview__partials" v-if="building.phase">
                            Etapa <strong class="text--info">{{ building.phase.title }}</strong>
                        </span>
                    </p>

                    <div v-if="building.phaseId" class="badge">{{ building.phaseId }}</div>

                    <div class="overview__images">
                        <image-container :images="building.images" :building-id="building.id" image-size="small"/>
                    </div>
                </div>
            </elementary-section>
        </div>
    </div>
</template>

<script>
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import UpdateBuildingDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/Building/UpdateBuildingDialog';
import ImageContainer from '@/modules/ProjectModule/modules/OptionModule/components/Building/Image/ImageContainer';
import ElementarySection from "@/components/Content/ElementarySection";
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'BuildingList',
    components: {CustomButton, ElementarySection, ImageContainer},
    computed:   {
        buildings() {
            return this.$store.getters['projects/project/building/buildings'];
        }
    },
    methods:    {
        update(buildingId) {
            this.$modal.show(UpdateBuildingDialog, {buildingId}, defaultModalParameters());
        },
        remove(building) {
            const {id, title} = building;
            this.$modal.show('dialog', {
                text:    'Opravdu chcete budovu <strong>' + title + '</strong> odstranit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odstranit',
                        handler: () => {
                            this.$store.dispatch('projects/project/building/removeBuilding', id)
                                .catch((message) => this.$dmv.notifyError(message));
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        },
    }
}
</script>
